"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupBy = exports.summary = exports.streamToObject = exports.recordToStream = exports.streamToDataItem = exports.dayLabel = exports.dayShortLabel = exports.DayLabel = exports.Days = void 0;
exports.Days = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
exports.DayLabel = ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"];
function dayShortLabel(day) {
    return dayLabel(day).substring(0, 3);
}
exports.dayShortLabel = dayShortLabel;
function dayLabel(day) {
    var _a;
    return (_a = exports.DayLabel[exports.Days.indexOf(day)]) !== null && _a !== void 0 ? _a : "-";
}
exports.dayLabel = dayLabel;
function streamToDataItem(list) {
    return list.map(function (i) {
        var day = i[0], hour = i[1], value = i[2];
        return { day: exports.Days[day], hour: hour, value: value };
    });
}
exports.streamToDataItem = streamToDataItem;
function recordToStream(data) {
    var result = [];
    for (var _i = 0, _a = Object.entries(data); _i < _a.length; _i++) {
        var _b = _a[_i], k = _b[0], v = _b[1];
        for (var _c = 0, v_1 = v; _c < v_1.length; _c++) {
            var weekday = v_1[_c];
            result.push([exports.Days.indexOf(k), weekday[0], weekday[1]]);
        }
    }
    return result;
}
exports.recordToStream = recordToStream;
function streamToObject(data) {
    var d = recordToStream(data);
    return d.map(function (i) { return ({ day: exports.Days[i[0]], hour: i[1], value: i[2] }); });
}
exports.streamToObject = streamToObject;
function summary(data, field) {
    var items = streamToObject(data);
    var list = groupBy(items, field);
    return Object.values(list).map(function (a) {
        var first = a[0];
        return [first[field], a.reduce(function (c, b) { return b.value + c; }, 0)];
    });
}
exports.summary = summary;
function groupBy(list, grouper) {
    var result = {};
    for (var i in list) {
        var element = list[i];
        var key = element[grouper];
        if (key in result) {
            result[key].push(element);
            continue;
        }
        result[key] = [element];
    }
    return result;
}
exports.groupBy = groupBy;
//# sourceMappingURL=week-chart-model.js.map